class CartUpsell extends HTMLElement {
    constructor(){
        super()

        this.variantId = this.dataset.variantId
        this.cart = this.closest('m-cart-drawer')
        this.addToCartButton = this.querySelector('.cart-upsells__item-add')
        this.addToCartButton.addEventListener('click', (e) => {
            e.preventDefault()
            this.addToCartButton.classList.add('atc-loading')
            this.addToCart()
        })
    }

    addToCart(){
        fetch(`/cart/add.js`, {
            method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: this.variantId,
                quantity: 1,
                properties: {
                    "_product_type": this.dataset.productType
                }
            })
        })
        .then(response => response.json())
        .then(response => {
            const sectionId = document.querySelector("m-cart-drawer").dataset.section || "cart-drawer"
            fetch(`/cart?section_id=${sectionId}`)
            .then(response => response.text())
            .then(data=>{
                console.log("TESTt")
                const html = new DOMParser().parseFromString(data, 'text/html')
                this.closest('.m-cart-drawer--inner').innerHTML = html.querySelector('.m-cart-drawer--inner').innerHTML
                console.log(this.cart)
                console.log(this.cart.querySelector('.m-cart-drawer--close-icon'))
                this.cart.querySelector('.m-cart-drawer--close-icon').addEventListener('click',()=>{
                    this.cart.close()
                });
                //TODO: Add eulerian data
                console.log("TEST")
                try {
                    const eulerianElement = document.getElementById('eulerian-items-data');
                    if (eulerianElement) {
                      const data = JSON.parse(eulerianElement.innerText);
                      const eulerianData = ["path","" + window.location.pathname + ""];
                      
                      // Convert nested object to flat array
                      Object.entries(data.eulerianData).forEach(([key, value]) => {
                        if (key === 'products') {
                          // Handle products array
                          value.forEach(product => {
                            Object.entries(product).forEach(([prodKey, prodValue]) => {
                              eulerianData.push(prodKey, prodValue.toString());
                            });
                          });
                        } else {
                          eulerianData.push(key, value.toString());
                        }
                      });
                      eulerianData.push('upsell-carrito','add')
                      eulerianData.push('pais', window.userCountry || Shopify.country);
                      eulerianData.push('enopagedt', '1')
                      console.log('Eulerian data array:', eulerianData);
                      console.log(this.cart.querySelector('m-cart-drawer-items'))
                      this.cart.querySelector('m-cart-drawer-items').addCartGift()
                      this.cart.querySelector('m-cart-drawer-items').checkCartGift()
                      if (typeof EA_push === 'function') {
                        EA_push(eulerianData);
                      }
                    }
                  } catch (error) {
                    console.error('Error handling Eulerian data:', error);
                }
            })
        })
    }
}
customElements.define('cart-upsell', CartUpsell)